import PropTypes from 'prop-types';
import { Box, Card, Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import StudentAssessmentRow from './StudentAssessmentRow';
import { Subject, SubjectLabel, ROW_GRID, gradeRangeLabel } from './constants';

const COLUMNS = ['Student', 'Assessment type', 'Score', 'Goals', ''];

export default function GroupCard({ group, term, onSaved, onSavingChange }) {
    const theme = useTheme();
    const badge =
        group.subject === Subject.Math
            ? { bg: theme.palette.secondary.light, text: theme.palette.secondary.dark }
            : { bg: theme.palette.primary.light, text: theme.palette.primary.dark };
    const details = [group.providerName, gradeRangeLabel(group.rows.map((r) => r.grade)), group.schoolName].filter(Boolean).join(' · ');

    return (
        <Card variant="outlined" sx={{ mb: 2.5, pb: 1, borderColor: theme.palette.grey[200], borderRadius: 3 }}>
            <Box sx={{ px: { xs: 2, sm: 3 }, pt: 2.5, pb: { xs: 1, lg: 2 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography fontWeight={500} fontSize={16} sx={{ color: theme.palette.grey[900] }}>
                        Group {group.groupName}
                    </Typography>
                    <Chip
                        size="small"
                        label={SubjectLabel[group.subject]}
                        sx={{ height: 22, fontSize: 12, fontWeight: 500, color: badge.text, backgroundColor: badge.bg }}
                    />
                </Box>
                {details && (
                    <Typography fontSize={13} sx={{ color: theme.palette.grey[600], mt: 0.5 }}>
                        {details}
                    </Typography>
                )}
            </Box>

            <Box
                sx={{
                    ...ROW_GRID,
                    display: { xs: 'none', lg: 'grid' },
                    px: 3,
                    pb: 0.5
                }}
            >
                {COLUMNS.map((c) => (
                    <Typography
                        key={c || 'actions'}
                        fontSize={11}
                        fontWeight={500}
                        sx={{ color: theme.palette.grey[500], textTransform: 'uppercase', letterSpacing: 0.5 }}
                    >
                        {c}
                    </Typography>
                ))}
            </Box>

            {group.rows.map((row) => (
                <StudentAssessmentRow
                    key={`${row.studentId}-${row.subject}`}
                    row={row}
                    term={term}
                    onSaved={onSaved}
                    onSavingChange={onSavingChange}
                />
            ))}
        </Card>
    );
}

GroupCard.propTypes = {
    // The group's details, taken from its first row, plus every row in the group
    group: PropTypes.shape({
        groupName: PropTypes.string,
        subject: PropTypes.number.isRequired,
        providerName: PropTypes.string,
        schoolName: PropTypes.string,
        rows: PropTypes.arrayOf(PropTypes.object).isRequired
    }).isRequired,
    term: PropTypes.object.isRequired,
    onSaved: PropTypes.func.isRequired,
    onSavingChange: PropTypes.func.isRequired
};
